export const NETWORK_ERROR_MESSAGE = "Произошла ошибка"
